// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGreenEnergy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      d="M18.737 5.77v10.721a6.137 6.137 0 1 1-12.274 0v-4.33"
    />
    <path
      stroke="currentColor"
      d="M10.666 10.053A2.098 2.098 0 0 1 8.57 12.15H4.964a2.095 2.095 0 0 1-2.095-2.098v-3.59h7.783z"
    />
    <path
      stroke="currentColor"
      d="M2.719 5.564H10.5a.445.445 0 0 1 .45.45.449.449 0 0 1-.45.449H2.72a.45.45 0 1 1 0-.899zM4.364 1.971a.6.6 0 0 1 1.2 0v3.007h-1.2zM7.958 1.971a.6.6 0 1 1 1.196 0v3.007H7.958z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.115 7.958h3.292a.45.45 0 1 1 0 .898H5.115a.45.45 0 1 1 0-.898zM5.115 9.754h3.292a.45.45 0 1 1 0 .899H5.115a.45.45 0 0 1 0-.899z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      d="M15.744 11.348V6.206a2.863 2.863 0 0 1 2.863-2.863h.25a2.863 2.863 0 0 1 2.863 2.863v5.142c0 .23-.998 1.372-2.993 3.43.007.026-.987-1.116-2.983-3.43zM21.73 8.256l-2.993 2.997"
    />
  </svg>
);
export default SvgGreenEnergy;
